import { useMutation, useQueryClient } from 'react-query';

import { status200 } from '../status.utils';
import axios from '../axios/axiosInstance';
import apiPaths from '../apiPaths';

const updateTranslation = ({ translation, id }) =>
  axios.put(`${apiPaths.translations}/${id}`, translation, status200).then((resp) => resp.data);

const useUpdateTranslation = () => {
  const queryClient = useQueryClient();
  return useMutation((values) => updateTranslation(values), {
    onSuccess: () => {
      queryClient.resetQueries('translations');
    },
    onError: (error) => {
      return error;
    },
    onSettled: () => {
      queryClient.invalidateQueries('translations');
    },
  });
};

export default useUpdateTranslation;
